module.exports = __webpack_public_path__ + "75afdfb7.svg";